export default {
	globalError: 'Error has occurred',
	invalidUsername_GENERATE: 'Account name is taken',
	invalidUsername_RESOURCE: 'Account not found',
	notEnoughBalance_RESOURCE: 'At the moment we cannot perform the operation, since the balance of our service is reserved for other operations. We know about this and already increasing it which will take some time. Try later or change to lower amount of resources',
	notEnoughBalance_GENERATE: 'At the moment we cannot perform the operation, since the balance of our service is reserved for other operations. We know about this and already increasing it which will take some time. Try later'
}
